import "../../../../assets/FollowupS4/scss/modules/custom.scss";
import "../../../../assets/FollowupS4/scss/modules/id_upload.scss";
import loaderSvg from "../../../../assets/FollowupS4/img/loader-review2.svg";//
import logo from "../../../../assets/FollowupS4/img/logo-white.png";
import uplaodGif from "../../../../assets/FollowupS4/img/upload.gif";
import uplaodPng from "../../../../assets/FollowupS4/img/upload.png";
import successTick from "../../../../assets/FollowupS4/img/tick.png";

import Footer from "./Footer";
import IdPopUpload from "./IdPopUpload";
import { useContext, useEffect, useState } from "react";
import SupportingDocs from "./SupportingDocs";
import { useHistory } from "react-router-dom";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import AgreementNoPopup from "./AgreementNoPopup";
import { Api } from "../../../../api/Api";
import { queryString,urlParams } from "../../../../Utility/QueryString";


export default function ID_Upload_FLP_S4({uuid,removeFromPending,pendingQuestionnaire}) {
  const { visitorParameters } = useContext(VisitorParamsContext);
  const history = useHistory();
  const [idPopUp, setIdPopUp] = useState(false);
  const [supportDocPopup, setSupportDocPopup] = useState(false);
  const [loader, setLoader] = useState(true);
  const [supportDocSuccess, setSupportDocSucess] = useState(false);
  const [idUploadSuccess, setIdUploadSucess] = useState(false);
  const [agreementPopup, setAgreementPopup] = useState(false);

  const t2a_Validation = localStorage.getItem("t2aValidation");
  
  useEffect(() => {
    window.scrollTo(0, 0);
    const loaderTimer = setTimeout(() => {
      setLoader(false);
    }, 3000);
    //generatePdf();
    return () => clearTimeout(loaderTimer);
  }, []);
/*
  useEffect(()=>{
    if(!pendingQuestionnaire.includes('idUpload')){
      setIdUploadSucess(true);
    }
  
    if(!pendingQuestionnaire.includes('supportDoc')){
      setSupportDocSucess(true);
    }
  },[])
  
  const generatePdf = async () => {
    try {

      const responsepdf = Api.get(`/api/v1/vaq-quest-generate?uuid=${uuid}`, {});

    } catch (err) {
      console.error("Error generating PDF:", err);
    }
  };
  */

  // const cakePostApi = async () => {
  //   try {
  //     const responsecakePostApi = Api.get(`/api/v1/vaq-cake-post?uuid=${uuid}`, {});
  //   } catch (err) {
  //     console.error("Error CakePosting:", err);
  //   }
  // };

  const closeIdPopUp = () => {
    setIdPopUp(false);
  };

  return (
    <>
      <div className="VAQ_FLP_S4">
        <div className="FollowupS4 form-font">
          <section className="banner qs-section id-upload">
            <div className="container mt-5 mb-5">
              <div className="logo">
                <img src={logo} alt="TMS Legal Logo" />
              </div>
              {loader ? (
                <div className="vh-100 d-flex loader-wrap text-center text-light">
                  <div className="m-auto">
                    <img height={80} src={loaderSvg} alt="" />
                    <h6 className="mt-3">Analysing your answers</h6>
                  </div>
                </div>
              ) : (
                <div id="upload-section">
                  <div className="container">
                    <h2 className="thank-you text-white">Thank you</h2>
                    <h3 className="onboarding-message text-white">
                      {"1" === t2a_Validation
                        ? "Thank you for submitting your claim to TMS Legal. We have completed your digital ID check and it was successful. We will now email you copies of all signed documents and we will call you shortly to verify your details and answer any questions."
                        : "Your claim is now registered with us, and we will commence the onboarding process."}
                    </h3>
                    <div className="identity-icon">
                      <div className="uploadicons">
                        <img height={80} src={uplaodGif} alt="" />
                      </div>
                    </div>
                    <div className="instruction">
                      We need the following information to expedite your claim
                      process. <br />
                      Please upload the required documents.
                    </div>
                    <div className="dropdown-buttons">
                      {"0" === t2a_Validation && (
                        <label
                          className="dropdown-item"
                          onClick={() => setIdPopUp(true)}
                        >
                          Upload Your ID
                          <img
                            src={idUploadSuccess ? successTick : uplaodPng}
                            className="upload-icon"
                            alt="Upload Icon"
                          />
                          <input
                            type="button"
                            name="document1"
                            className="d-none"
                            data-bs-toggle="modal"
                            data-bs-target="#iduploadBackdrop"
                            data-click-id='idUpload_click'
                          />
                        </label>
                      )}
                      <label
                        className="dropdown-item"
                        onClick={() => setSupportDocPopup(true)}
                      >
                        Upload Supporting Documents
                        <img
                          src={supportDocSuccess ? successTick : uplaodPng}
                          className="upload-icon"
                          alt="Upload Icon"
                        />
                        <input
                          type="button"
                          name="document2"
                          className="d-none"
                          data-bs-toggle="modal"
                          data-bs-target="#quesBackdrop"
                          data-click-id='supportDoc_click'
                        />
                      </label>
                    </div>
                    <div className="footer-note">
                      Document should be Clear &amp; Legible | Entire Document
                      should be Captured
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
          <Footer />
          {idPopUp && (
            <IdPopUpload
              close={closeIdPopUp}
              setIdUploadSucess={setIdUploadSucess}
              //removeFromPending={removeFromPending}
            />
          )}
          {supportDocPopup && (
            <SupportingDocs
              setSupportDocPopup={setSupportDocPopup}
              setSupportDocSucess={setSupportDocSucess}
              setAgreementPopup={setAgreementPopup}
            //  removeFromPending={removeFromPending}
            />
          )}
          {agreementPopup && (
            <AgreementNoPopup
              setAgreementPopup={setAgreementPopup}
              setSupportDocPopup={setSupportDocPopup}
              setSupportDocSucess={setSupportDocSucess}
            //  removeFromPending={removeFromPending}
            />
          )}
        </div>
      </div>
    </>
  );
}
